import PageContainerBlank from '../../components/PageContainer/PageContainerBlank';
import PageEndBlank from '../../components/PageContainer/PageEndBlank';
import Testimony from '../../components/Testimony/Testimony';

const MeetTheTeam = () => {
	return (
		<div>
			<PageContainerBlank />

			<h1>Officer Testimonies</h1>

			<div className="testimony-flex">
				<Testimony
					officerName="Craig Redding"
					officerTitle="President"
					officerImage="/static/images/officers/CraigBust.webp"
					officerTestimony={
						<p className="justify"><span className="tab"></span>Being the Holy Name president, OCIA Coordinator, and an active parishioner and volunteer, I have learned that any opportunity to join together with faith-filled brothers always leads to spiritual growth for all. The Holy Name Society especially helps members to grow in faith and share in that faith as we journey together toward God's Kingdom.</p>
					}
					officerAttributesList={
						["Humble", "Inquisitive", "Thoughtful"]
					}
					officerInterestsList={
						["Traveling", "Hiking & biking", "Studying true crime"]
					}
					inverted={false}
				/>
				<Testimony
					officerName="Dick Arigo"
					officerTitle="Vice President"
					officerImage="/static/images/officers/DickBust.webp"
					officerTestimony={
						<p className="justify"><span className="tab"></span>I have been an active member of St. Joseph parish for over forty years, serving as an Extraordinary Minister, Parish Council member and chairman, Holy Name President, and more. The Holy Name Society is special to me because I have met so many good and holy men through this association. The Holy Name has made me a better Catholic in my faith journey and I highly recommend all men to become members.</p>
					}
					officerAttributesList={
						["Loyal", "Dependable", "Handy"]
					}
					officerInterestsList={
						["Golf", "Bicycling", "Playing cards"]
					}
					inverted={true}
				/>
				<Testimony
					officerName="Rick Harmer"
					officerTitle="Secretary"
					officerImage="/static/images/officers/RickBust.webp"
					officerTestimony={
						<p className="justify"><span className="tab"></span>Whether playing basketball, baseball, or running marathons, I have always been part of a team that made me better. When I started on my journey to become a better Christian, I found that the path is extremely difficult, and I needed help. The late Jim Martin talked me into joining the Holy Name Society. I found a group of men who were welcoming and very supportive. Although the journey is still difficult, these men have helped me through some difficult times and have always been a great influence on me. I encourage any man who is looking for teammates to join the Holy Name Society.</p>
					}
					officerAttributesList={
						["Dependable", "Resourceful", "Altruistic"]
					}
					officerInterestsList={
						["Golf", "Walking", "Reading"]
					}
					inverted={false}
				/>
				<Testimony
					officerName="Stephen Roth"
					officerTitle="Treasurer"
					officerImage="/static/images/officers/SteveBust.webp"
					officerTestimony={
						<p className="justify"><span className="tab"></span>I am a former Secretary of the Holy Name Society, a member of the Hanover Knights of Columbus, a youth basketball coach at St. Joseph's for more than ten years, and the current stadium announcer at Delone Catholic Friday night football games. I was brought into the Holy Name by Jim Martin, who has passed away, and it has given me a renewed vigor in helping others. The Holy Name is a great place for fellowship and focus on the goal of giving back to the parish and community through various programs we sponsor.</p>
					}
					officerAttributesList={
						["Mysterious", "Unknown", "Unspecified"]
					}
					officerInterestsList={
						["Helping others", "Spending time with family/grandchildren", "Fishing"]
					}
					inverted={true}
				/>
				<Testimony
					officerName="Marc Heppding"
					officerTitle="Lay Chaplain"
					officerImage="/static/images/officers/MarcBust.webp"
					officerTestimony={
						<p className="justify"><span className="tab"></span>I became a member of the Holy Name Society at St. Joseph in 2022 after having joined at Our Lady of the Fields in Davidson, MD many years ago. The Holy Name Society is special to me because it consists of a group of men who are here to serve our Lord and do His will. Serving as Lay Chaplain has been an honor and a motivator for me to learn more and share everything to a group of men who are eager to learn.</p>
					}
					officerAttributesList={
						["Quiet", "Caring", "Humble"]
					}
					officerInterestsList={
						["Creating miniatures (Rosary-making)", "Researching Biblical mysteries", "Cruising"]
					}
					inverted={false}
				/>
			</div>

			<PageEndBlank />
		</div>
	);
};

export default MeetTheTeam;